import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import serviceEndpoints from '../../../config/serviceEndpoints';
import staticGateway from '../../../config/service';
import { getQueryParams } from '../../../utils/utils';

export const getLeagueAdminsList = createAsyncThunk(
    '/api/superAdmin/getLeagueAdmin',
    async (data, { rejectWithValue }) => {
        const body = { ...data, platform: 'web' };
        try {
            const response = await staticGateway.get(
                `${serviceEndpoints.getTableData}/LeagueAdmin?${getQueryParams(data)}`,
                body
            );
            const { success, message } = response.data;
            if (success) {
                return response?.data;
            }
            return rejectWithValue(message);
        } catch (error) {
            return error.message;
        }
    }
);

export const deleteRow = createAsyncThunk('/api/superAdmin/deleteUser', async (data, { rejectWithValue }) => {
    const body = { ...data, platform: 'web' };
    try {
        const response = await staticGateway.delete(`${serviceEndpoints.deleteTableRow}/${data}`, body);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

const slice = createSlice({
    name: 'user',
    initialState: {
        resMsg: '',
        userList: {},
        adminData: {},
        isLoading: false,
        isDeleted: false,
    },

    extraReducers: (builder) => {
        builder

            .addCase(getLeagueAdminsList.pending, (state) => {
                state.isLoading = true;
                state.resMsg = '';
                state.adminData = {};
                state.isDeleted = false;
            })
            .addCase(getLeagueAdminsList.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.userList = {};
                state.adminData = {};
            })
            .addCase(getLeagueAdminsList.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.adminData = payload.result || null;
                if (payload.result.rows) {
                    state.userList = payload.result.rows;
                } else state.userList = current(state).userList;
            })
            .addCase(deleteRow.pending, (state) => {
                state.isLoading = true;
                state.resMsg = '';
                state.isDeleted = false;
            })
            .addCase(deleteRow.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.isDeleted = false;
            })
            .addCase(deleteRow.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.isDeleted = payload?.statusCode === 200 && payload.message;
            });
    },
});

export default slice.reducer;
